const emailRegex = /.+@.+\..{2,}/i;

export const isValidEmail = emailString => emailRegex.test(emailString);